export enum EAreaMeasure {
  SquareMeters = 'м\u00B2',
  Ares = 'сот.',
}
